// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3IUWG","buttons":"Footer_buttons__1DtZt"};